<template>
  <div class="grid">
    <v-progress-linear color="warning" indeterminate rounded height="3" v-if="isLoading"></v-progress-linear>
    <v-form ref="form" lazy-validation v-on:submit.prevent v-if="editedItem && !isLoading">
      <div class="grid-title">
        <h4>
          {{ $t(isAddNew ? "ADD_NEW_DYNAMIC_PRICING" : "EDIT_DYNAMIC_PRICING") }}
        </h4>
      </div>
      <div class="grid-body p-3 border-top-unset mb-4">
        <v-row>
          <v-col sm="12">
            <label>{{ $t("DYNAMIC_NAME") }} *</label>
            <v-text-field v-model="editedItem.nameVi" counter maxlength="250" class="input-counter" :rules="ruleName"
              outlined dense>
            </v-text-field>
          </v-col>
          <v-col sm="12" class="py-0">
            <label>{{ $t("DYNAMIC_DESCRIPTION") }}</label>
            <v-textarea :rows="3" :rules="ruleDescNotRequired" counter="3000" maxlength="3000" class="input-counter"
              v-model="editedItem.descriptionVi" dense outlined>
            </v-textarea>
          </v-col>
          <v-col sm="12" class="py-0">
            <v-checkbox v-model="editedItem.active" :label="$t('ACTIVE')"></v-checkbox>
          </v-col>
        </v-row>
        <v-divider />
        <label class="label-title"> {{ $t("PRICE_CALCULATION_FORMULA") }}</label>
        <div class="d-flex">
          <div class="w-50">
            <v-subheader class="pl-0"> {{ $t("CRITERIA") }} </v-subheader>
            <v-radio-group v-model="editedItem.appliedBy" row class="mt-0" @change="changeApplyBy">
              <v-radio v-for="i in optionApplyBy" :label="i.label" :value="i.key"></v-radio>
            </v-radio-group>
          </div>
          <div>
            <v-subheader class="pl-0"> {{ $t("TARGET_APPLY") }} </v-subheader>
            <v-radio-group v-model="editedItem.appliedFor" row class="mt-0">
              <v-radio v-for="i in optionApplyFor" :value="i.key">
                <template v-slot:label>
                  <div>
                    {{ i.label }}
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="primary" dark v-bind="attrs" v-on="on" class="material-icons-outlined" size="17">
                          info
                        </v-icon>
                      </template>
                      <div class="text-center">
                        <p>{{ $t("ROOM_CAPACCITY_FORMULA") }}</p>
                        <p>P = A / [A + (B - DU)] &#215; 100</p>
                        <p>P: {{ $t("ROOM_OCCUPANCY") }}</p>
                        <p>
                          A:
                          {{
                            i.key === 0
                            ? $t("TOTAL_NUMBER_OF_ROOMS_BY_ROOM_CLASS")
                            : $t("TOTAL_NUMBER_OF_ROOMS_BY_HOTEL")
                          }}
                        </p>
                        <p>
                          B:
                          {{
                            i.key === 0
                            ? $t("TOTAL_NUMBER_OF_AVAILABLE_ROOMS_BY_ROOM_CLASS")
                            : $t("TOTAL_NUMBER_OF_AVAILABLE_ROOMS_BY_HOTEL")
                          }}
                        </p>
                        <p>
                          DU:
                          {{
                            i.key === 0
                            ? $t("DU_DESCRIPTION_OF_ROOM_TYPE")
                            : $t("DU_DESCRIPTION_OF_HOTEL")
                          }}
                        </p>
                      </div>
                    </v-tooltip>
                  </div>
                </template>
              </v-radio>
            </v-radio-group>
          </div>
        </div>
        <v-divider />
        <div>
          <p class="mt-2">{{ $t("_ACTIVITY.APPLY_DATE") }} *</p>
          <div>
            <date-picker style="width: 195px !important" :disabled-date="notBeforeToday" @input="changDateApply()"
              :confirm="false" :confirm-text="$t('CONFIRM')" :clearable="false"
              :popup-class="'popup-calendar-desktop-detailhotel'" v-model="applyDate" :lang="languageDate"
              :format="'DD/MM/YYYY'" :shortcuts="[]" range placeholder="Select date range"
              :class="!applyDate[0] ? 'requied-date' : ''">
            </date-picker>
          </div>
          <v-divider />
          <p class="mt-3">{{ $t("DAYS_NOT_APPLY") }}</p>
          <div class="d-flex flex-wrap">
            <div v-for="date in editedItem.dynamicPricingBlackoutDTOS" class="mr-4 mb-3" v-if="date.blackout === true">
              <date-picker style="width: 195px !important" :disabled-date="notBeforeToday" :confirm="false"
                :confirm-text="$t('CONFIRM')" :clearable="false" :popup-class="'popup-calendar-desktop-detailhotel'"
                v-model="date.dates" :lang="languageDate" :format="'DD/MM/YYYY'" :shortcuts="[]" range
                placeholder="Select date range" @change="_forceUpdate()">
              </date-picker>
              <v-btn color="error" icon x-small @click="date.blackout = false; _forceUpdate()">
                <v-icon size="16"> delete </v-icon>
              </v-btn>
            </div>
          </div>
          <v-btn color="primary" small @click="addBlackOut()" outlined class="btn-popup-special-days-price fs-10"><v-icon
              size="16">add</v-icon>
            {{ $t("SERVICE.ADD_DAYS_NOT_APPLY") }}</v-btn>
        </div>
        <v-divider class="mb-0" />
        <v-subheader class="pl-0"> {{ $t("CONFIG_TYPE") }} </v-subheader>
        <v-radio-group v-model="configType" row class="mt-0">
          <v-radio v-for="i in optionConfigType" :label="i.label" :value="i.key"></v-radio>
        </v-radio-group>
        <v-divider />
        
        <div class="d-flex align-center mt-3">
          <div class="mr-3 text-nowrap">
            {{ $t("APPLY_FOR") }}
          </div>
          <v-autocomplete  item-text="text" item-value="value" :items="productList" v-model="productSelect" outlined dense
            chips multiple @change="changeProduct" class="w-100">
            <template v-slot:prepend-item>
              <p class="mx-3 mt-1">
                <a class="text-primary" @click="productSelect = productList.map(e => e.value); changeProduct()">
                  {{ $t('SELECT_ALL') }}
                </a> |
                <a class="text-primary" @click="productSelect = []; changeProduct()">
                  {{
                    $t('UN_SELECT_ALL')
                  }}
                </a>
              </p>
            </template>

            <template v-slot:selection="{ item, index }">
              <v-chip color="primary" v-if="index === 0 || index === 1 || index === 2" v-bind="item.attrs"
                :input-value="item.selected" close @click:close="remove(index, productSelect)" @click="item.select">
                <span>{{ item.text }}</span>
              </v-chip>
              <span v-if="index === 3" class="grey--text caption">(+{{ productSelect.length - 1 }})</span>
            </template>
            <template slot="no-data">
              <div class="no-data">{{ $t("NO_DATA") }}</div>
            </template>
          </v-autocomplete>
        </div>
        <v-divider />
        <div class="config-dynamic">
          <template
            v-for="(item, index) in product.filter(e => productSelect.includes(e.roomType.id + '|' + e.ratePlan.id))">
            <div v-if="index === 0" class="article-item mt-3">
              <div class="d-flex">
                <p class="font-weight-bold pl-5 mr-auto">
                  {{ item.roomType.nameVi + ' - ' + item.ratePlan.nameVi }} ({{ item.totalRoom }} {{ $t('ROOM') }})
                </p>
                <v-checkbox v-model="selectModel" class="p-0 mt-0" :label="$t('USE_MODEL') + ' *'"
                  @change="changeModel()"></v-checkbox>
              </div>

              <div class="ml-3 d-flex align-center">
                <div class="mr-auto">
                  <b-form-group class="mb-0">
                    <label class="mb-2">{{ $t("CHANNEL_APPLY") }} * &nbsp;
                      (<a class="text-primary text-decoration-underline" @click="checkAll(item)">{{ $t('SELECT_ALL')
                      }}</a>
                      |
                      <a class="text-primary text-decoration-underline" @click="removeAll(item)">{{ $t('UN_SELECT_ALL')
                      }}</a>)</label>
                    <b-form-checkbox-group v-model="item.selectedOta" :options="item.otaDtos" class="mb-3"
                      :state="errorCheckOta && item.selectedOta.length === 0 ? false : null" value-field="id"
                      text-field="nameVi" @change="_forceUpdate()"></b-form-checkbox-group>
                  </b-form-group>

                </div>
              </div>

              <v-row class="d-un-sticky">
                <v-col md="3" class="pt-0 pb-0">
                  <v-row>
                    <v-col class="fs-12">{{
                      optionApplyBy.find((e) => e.key === editedItem.appliedBy).label
                    }}</v-col>
                  </v-row>
                </v-col>
                <v-col md="9" class="pt-0 pb-0">
                  <v-row v-if="configType === 0">
                    <v-col class="text-center fs-12" v-for="day in daysOfWeek">{{
                      day.value
                    }}</v-col>
                  </v-row>
                  <v-row v-if="configType === 1">
                    <v-col class="text-left fs-12">{{
                      $t('FOMULA_FROM_TO')
                    }}</v-col>
                  </v-row>
                </v-col>
              </v-row>
              <div v-for="(dynamicPricing, index) in item.dynamicPricingRangeDTOS" :key="`dynamicPricingRangeDTOS_${index}`">
                <v-row class="mt-2  ">
                  <v-col md="3" class="pt-0 pb-0 d-flex align-items-center">
                    <v-row>
                      <v-col class="fs-12 d-flex justify-content-start align-items-center d-multiplier py-0">
                        <div class="mr-2">
                          {{ $t('FROM') }}
                        </div>
                        <div class="mr-2">
                          <vue-numeric class="input-multiplier rounded"
                            :class="dynamicPricing.minVal >= 0 ? '' : 'border-danger'" currency=" "
                            v-model="dynamicPricing.minVal" :min="index === 0 ? 0
                              : item.dynamicPricingRangeDTOS[index - 1]['maxVal']"
                            :max="editedItem.appliedBy === 0 ? dynamicPricing.maxVal - 0.01 : dynamicPricing.maxVal - 1"
                            :precision="editedItem.appliedBy === 0 ? 2 : 0" :empty-value="index === 0 ? 0
                              : item.dynamicPricingRangeDTOS[index - 1]['maxVal']"
                            @change="changeModel()"></vue-numeric>
                        </div>
                        <div class="mr-2">
                          {{
                            $t("TO_LESS")
                          }}
                        </div>
                        <div class="mr-1">
                          <vue-numeric class="input-multiplier rounded"
                            :class="dynamicPricing.maxVal ? '' : 'border-danger'" currency=" "
                            v-model="dynamicPricing.maxVal" :min="dynamicPricing.minVal" :max="index === item.dynamicPricingRangeDTOS.length - 1 ||
                              item.dynamicPricingRangeDTOS.length === 1
                              ? editedItem.appliedBy === 0
                                ? 100
                                : 99999999999
                              : item.dynamicPricingRangeDTOS[index + 1]['minVal']
                              " :precision="editedItem.appliedBy === 0 ? 2 : 0" @change="changeModel()"></vue-numeric>
                          {{ editedItem.appliedBy === 0 ? "%" : $t("ROOM") }}
                        </div>
                        <v-btn color="error" icon v-if="item.dynamicPricingRangeDTOS.length > 1"
                          @click="remove(index, item.dynamicPricingRangeDTOS); changeModel()">
                          <v-icon size="17"> delete </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col md="9" class="pt-0 pb-0 px-0" v-if="configType === 0">
                    <v-row class="small-gutters">
                      <v-col class="pb-0 pt-0 d-flex">
                        <v-icon size="16" color="primary" @click="copyPrice(dynamicPricing); changeModel()" class="pr-3"
                          :title="$t('COPY')">content_paste_go</v-icon>
                        <number-ptd :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn" dense outlined
                          v-model="dynamicPricing.paxMonday" :disabled="dateDisabled.MON"
                          :rules="dateDisabled.MON ? '' : ruleMoney" @input="changeModel()" />

                      </v-col>
                      <v-col class="pb-0 pt-0">
                        <number-ptd :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn" dense outlined
                          v-model="dynamicPricing.paxTuesday" :disabled="dateDisabled.TUE"
                          :rules="dateDisabled.TUE ? '' : ruleMoney" @input="changeModel()" />
                      </v-col>
                      <v-col class="pb-0 pt-0">
                        <number-ptd :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn" dense outlined
                          v-model="dynamicPricing.paxWednesday" :disabled="dateDisabled.WED"
                          :rules="dateDisabled.WED ? '' : ruleMoney" @input="changeModel()" />
                      </v-col>
                      <v-col class="pb-0 pt-0">
                        <number-ptd :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn" dense outlined
                          v-model="dynamicPricing.paxThursday" :disabled="dateDisabled.THU"
                          :rules="dateDisabled.THU ? '' : ruleMoney" @input="changeModel()" />
                      </v-col>
                      <v-col class="pb-0 pt-0">
                        <number-ptd :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn" dense outlined
                          v-model="dynamicPricing.paxFriday" :disabled="dateDisabled.FRI"
                          :rules="dateDisabled.FRI ? '' : ruleMoney" @input="changeModel()" />
                      </v-col>
                      <v-col class="pb-0 pt-0">
                        <number-ptd :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn" dense outlined
                          v-model="dynamicPricing.paxSaturday" :disabled="dateDisabled.SAT"
                          :rules="dateDisabled.SAT ? '' : ruleMoney" @input="changeModel()" />
                      </v-col>
                      <v-col class="pb-0 pt-0">
                        <number-ptd :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn" dense outlined
                          v-model="dynamicPricing.paxSunday" :disabled="dateDisabled.SUN"
                          :rules="dateDisabled.SUN ? '' : ruleMoney" @input="changeModel()" />
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col md="9" class="pt-0 pb-0 px-0" v-if="configType === 1">
                    <div class="d-flex align-center d-multiplier txt-nowrap">
                      <div class="mr-1">
                        <span class="font-weight-bold">C = (B &#177;</span>
                      </div>
                      <div>
                        <number-ptd class="input-plus fs-10"
                          :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn" dense :outlined="false" :allowMinusNumber="true"
                          v-model="dynamicPricing.rateAdditional" :rules="ruleRequiedNoMess" @input="changeModel()" />
                      </div>
                      <span class="font-weight-bold pr-1">) &#215; </span>
                      <div class="mr-1">
                        <number-ptd class="input-multiplier" :options="multiplierOption" dense :outlined="false"
                          v-model="dynamicPricing.rateIndex" :rules="ruleRequiedNoMess" @input="changeModel()" />
                      </div>
                      <span class="font-weight-bold pl-1 pr-1"> &#177; </span>
                      <div class="ml-1">
                        <number-ptd class="input-plus" :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn"
                          dense :outlined="false" :allowMinusNumber="true" v-model="dynamicPricing.rateSupplement" :rules="ruleRequiedNoMess"
                          @input="changeModel()" />
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </div>
              <v-row class="mt-2">
                <v-col class="pt-0 pb-0">
                  <v-btn color="primary" outlined x-small @click="addDynamic(item); changeModel()">
                    <v-icon color="#173d8f" small>add</v-icon> {{ $t('ADD_RANGE') }}
                  </v-btn>
                </v-col>
              </v-row>
              <v-divider />
            </div>

          </template>
          <b-collapse id="collapse-1" class="mt-2" v-model="toggle">
            <div v-for="(item, index) in product.filter(e => productSelect.includes(e.roomType.id + '|' + e.ratePlan.id))"
              class="mt-3" :key="`dynamicPricingRangeDTOS_productSelect_${index}`">
              <div v-if="index > 0" class="article-item">
                <p class="font-weight-bold  pl-5">
                  {{ item.roomType.nameVi + ' - ' + item.ratePlan.nameVi }} ({{ item.totalRoom }} {{ $t('ROOM') }})
                </p>

                <div class="ml-3 d-flex align-center">
                  <div class="mr-auto">
                    <b-form-group class="mb-0">
                      <label class="mb-2">{{ $t("CHANNEL_APPLY") }} * &nbsp;
                        (<a class="text-primary text-decoration-underline" @click="checkAll(item)">{{ $t('SELECT_ALL')
                        }}</a>
                        |
                        <a class="text-primary text-decoration-underline" @click="removeAll(item)">{{ $t('UN_SELECT_ALL')
                        }}</a>)</label>
                      <b-form-checkbox-group v-model="item.selectedOta" :options="item.otaDtos" class="mb-3"
                        value-field="id" text-field="nameVi" @change="_forceUpdate()"
                        :state="errorCheckOta && item.selectedOta.length === 0 ? false : null"></b-form-checkbox-group>
                    </b-form-group>
                  </div>
                </div>

                <v-row class="d-un-sticky">
                  <v-col md="3" class="pt-0 pb-0">
                    <v-row>
                      <v-col class="fs-12">{{
                        optionApplyBy.find((e) => e.key === editedItem.appliedBy).label
                      }}</v-col>
                    </v-row>
                  </v-col>
                  <v-col md="9" class="pt-0 pb-0">
                    <v-row v-if="configType === 0">
                      <v-col class="text-center fs-12" v-for="day in daysOfWeek">{{
                        day.value
                      }}</v-col>
                    </v-row>
                    <v-row v-if="configType === 1">
                      <v-col class="text-left fs-12">{{
                        $t('FOMULA_FROM_TO')
                      }}</v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <div v-for="(dynamicPricing, index) in item.dynamicPricingRangeDTOS">
                  <v-row class="mt-2  ">
                    <v-col md="3" class="pt-0 pb-0 d-flex align-items-center">
                      <v-row>
                        <v-col class="fs-12 d-flex justify-content-start align-items-center d-multiplier py-0">
                          <div class="mr-2">
                            {{ $t('FROM') }}
                          </div>
                          <div class="mr-2">
                            <vue-numeric class="input-multiplier rounded"
                              :class="dynamicPricing.minVal >= 0 ? '' : 'border-danger'" currency=" "
                              v-model="dynamicPricing.minVal" :min="index === 0 ? 0
                                : item.dynamicPricingRangeDTOS[index - 1]['maxVal']"
                              :max="editedItem.appliedBy === 0 ? dynamicPricing.maxVal - 0.01 : dynamicPricing.maxVal - 1"
                              :precision="editedItem.appliedBy === 0 ? 2 : 0" :empty-value="index === 0 ? 0
                                : item.dynamicPricingRangeDTOS[index - 1]['maxVal']"></vue-numeric>
                          </div>
                          <div class="mr-2">
                            {{
                              $t("TO_LESS")
                            }}
                          </div>
                          <div class="mr-1">
                            <vue-numeric class="input-multiplier rounded"
                              :class="dynamicPricing.maxVal ? '' : 'border-danger'" currency=" "
                              v-model="dynamicPricing.maxVal" :min="dynamicPricing.minVal" :max="index === item.dynamicPricingRangeDTOS.length - 1 ||
                                item.dynamicPricingRangeDTOS.length === 1
                                ? editedItem.appliedBy === 0
                                  ? 100
                                  : 99999999999
                                : item.dynamicPricingRangeDTOS[index + 1]['minVal']
                                " :precision="editedItem.appliedBy === 0 ? 2 : 0"></vue-numeric>
                            {{ editedItem.appliedBy === 0 ? "%" : $t("ROOM") }}
                          </div>
                          <v-btn color="error" icon v-if="item.dynamicPricingRangeDTOS.length > 1"
                            @click="remove(index, item.dynamicPricingRangeDTOS)">
                            <v-icon size="17"> delete </v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col md="9" class="pt-0 pb-0 px-0" v-if="configType === 0">
                      <v-row class="small-gutters">
                        <v-col class="pb-0 pt-0 d-flex">
                          <v-icon size="16" color="primary" @click="copyPrice(dynamicPricing)" class="pr-3"
                            :title="$t('COPY')">content_paste_go</v-icon>
                          <vuetify-number :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn" dense outlined
                            v-model="dynamicPricing.paxMonday" :disabled="dateDisabled.MON"
                            :rules="dateDisabled.MON ? '' : ruleMoney" />

                        </v-col>
                        <v-col class="pb-0 pt-0">
                          <vuetify-number :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn" dense outlined
                            v-model="dynamicPricing.paxTuesday" :disabled="dateDisabled.TUE"
                            :rules="dateDisabled.TUE ? '' : ruleMoney" />
                        </v-col>
                        <v-col class="pb-0 pt-0">
                          <vuetify-number :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn" dense outlined
                            v-model="dynamicPricing.paxWednesday" :disabled="dateDisabled.WED"
                            :rules="dateDisabled.WED ? '' : ruleMoney" />
                        </v-col>
                        <v-col class="pb-0 pt-0">
                          <vuetify-number :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn" dense outlined
                            v-model="dynamicPricing.paxThursday" :disabled="dateDisabled.THU"
                            :rules="dateDisabled.THU ? '' : ruleMoney" />
                        </v-col>
                        <v-col class="pb-0 pt-0">
                          <vuetify-number :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn" dense outlined
                            v-model="dynamicPricing.paxFriday" :disabled="dateDisabled.FRI"
                            :rules="dateDisabled.FRI ? '' : ruleMoney" />
                        </v-col>
                        <v-col class="pb-0 pt-0">
                          <vuetify-number :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn" dense outlined
                            v-model="dynamicPricing.paxSaturday" :disabled="dateDisabled.SAT"
                            :rules="dateDisabled.SAT ? '' : ruleMoney" />
                        </v-col>
                        <v-col class="pb-0 pt-0">
                          <vuetify-number :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn" dense outlined
                            v-model="dynamicPricing.paxSunday" :disabled="dateDisabled.SUN"
                            :rules="dateDisabled.SUN ? '' : ruleMoney" />
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col md="9" class="pt-0 pb-0 px-0" v-if="configType === 1">
                      <div class="d-flex align-center d-multiplier txt-nowrap">
                        <div class="mr-1">
                          <span class="font-weight-bold">C = (B &#177;</span>
                        </div>
                        <div>
                          <number-ptd class="input-plus fs-10"
                            :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn" dense :outlined="false" :allowMinusNumber="true"
                            v-model="dynamicPricing.rateAdditional" :rules="ruleRequiedNoMess" />
                        </div>
                        <span class="font-weight-bold pr-1">) &#215; </span>
                        <div class="mr-1">
                          <number-ptd class="input-multiplier" :options="multiplierOption" dense :outlined="false"
                            v-model="dynamicPricing.rateIndex" :rules="ruleRequiedNoMess" />
                        </div>
                        <span class="font-weight-bold pl-1 pr-1"> &#177; </span>
                        <div class="ml-1">
                          <number-ptd class="input-plus" :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn" :allowMinusNumber="true"
                            dense :outlined="false" v-model="dynamicPricing.rateSupplement" :rules="ruleRequiedNoMess" />
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </div>
                <v-row class="mt-1">
                  <v-col class="pt-0 pb-0">
                    <v-btn color="primary" outlined x-small @click="addDynamic(item)">
                      <v-icon color="#173d8f" small>add</v-icon> {{ $t('ADD_RANGE') }}
                    </v-btn>
                  </v-col>
                </v-row>
                <v-divider />
              </div>
            </div>
          </b-collapse>
          <div class="text-left py-0 mb-3"
            v-if="product.filter(e => productSelect.includes(e.roomType.id + '|' + e.ratePlan.id)).length > 1">
            <v-btn x-small color="primary" dark @click="toggle = !toggle">
              {{ $t(!toggle ? 'SHOW_MORE' : 'UN_ALL_CAPACITY') }}
            </v-btn>
          </div>
        </div>
        <div class="d-flex align-center">
          <p class="mr-auto pb-0">* {{ $t('NOTE_ROOM_RATE') }}<br>
            * {{ $t('USE_MODEL') }}: {{ $t('MODEL_DESCRIPTION_PRICE') }} {{ $t('NOTE_MODEL_PRICE') }}
          </p>
          <v-btn color="primary" @click="update()">
            <template>{{ $t(isAddNew ? 'ADD_NEW' : "UPDATE") }}</template>
          </v-btn>
        </div>
      </div>
    </v-form>
  </div>
</template>

<script>
import { dynamicService } from "@/_services/SaleRoom/smart-pricing.service.js";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
import VueNumeric from "vue-numeric";
import { _alert } from "@/_helpers/function.js";
import { thisExpression } from "babel-types";
import numberInput from "@/components/Utils/Number-input.vue";
export default {
  components: {
    "date-picker": DatePicker,
    VueNumeric,
    "number-ptd": numberInput,
  },
  data() {
    return {
      editedItem: {
        nameVi: "",
        descriptionVi: "",
        active: true,
        appliedBy: 0,
        appliedFor: 1,
        dynamicPricingBlackoutDTOS: [],
        productDTOList: [],
      },
      isAddNew: true,
      optionApplyFor: [
        {
          label: this.$t("ACCORDING_TO_EACH_ROOM_CLASS"),
          key: 0,
        },
        {
          label: this.$t("ENTIRE_HOTEL"),
          key: 1,
        },
      ],
      optionApplyBy: [
        {
          label: this.$t("ROOM_OCCUPANCY"),
          key: 0,
        },
        {
          label: this.$t("NUMBER_OF_ROOMS_AVAILABLE"),
          key: 1,
        },
      ],
      optionConfigType: [
        {
          label: this.$t("BY_RATE"),
          key: 0,
        },
        {
          label: this.$t("BY_FORMULA"),
          key: 1,
        },
      ],
      configType: 0,
      applyDate: [],
      currentDate: moment().startOf("day").toDate(),
      product: [],
      productList: [],
      productSelect: [],
      daysOfWeek: [
        { code: "MON", value: this.$t("MONDAY") },
        { code: "TUE", value: this.$t("TUESDAY") },
        { code: "WED", value: this.$t("WEDNESDAY") },
        { code: "THU", value: this.$t("THURSDAY") },
        { code: "FRI", value: this.$t("FRIDAY") },
        { code: "SAT", value: this.$t("SATURDAY") },
        { code: "SUN", value: this.$t("SUNDAY") },
      ],
      currency: JSON.parse(localStorage.getItem("currency")),
      multiplierOption: {
        prefix: "",
        locale: "vi",
        length: 3,
        precision: 2,
      },
      objectCopy: null,
      isLoading: true,
      dateDisabled: {
        MON: true,
        TUE: true,
        WED: true,
        THU: true,
        FRI: true,
        SAT: true,
        SUN: true,
      },
      type: 'EDIT',
      toggle: false,
      selectModel: false,
      errorCheckOta: false
    };
  },
  created() {
    this.currency = this.priceOptionsVi.suffix;
    this.initialize();
  },
  watch: {
    applyDate(val) {
      this.editedItem.startDate = moment(val[0]).format("YYYY-MM-DD");
      this.editedItem.endDate = moment(val[1]).format("YYYY-MM-DD");
    },
  },
  methods: {
    changeModel() {
      if (this.selectModel && this.product.filter(e => this.productSelect.includes(e.roomType.id + '|' + e.ratePlan.id))[0]) {
        var objectCopy = JSON.parse(JSON.stringify(this.product.filter(e => this.productSelect.includes(e.roomType.id + '|' + e.ratePlan.id))[0].dynamicPricingRangeDTOS));
        this.product.filter(e => this.productSelect.includes(e.roomType.id + '|' + e.ratePlan.id)).forEach((item, index) => {
          if (index > 0) {
            item.dynamicPricingRangeDTOS = [];
            var ob = JSON.parse(JSON.stringify(objectCopy));
            ob.forEach((element, indexx) => {
              item.dynamicPricingRangeDTOS.push(element);
            });
          }

        });
        this.$forceUpdate();
      }
    },
    remove(index, array) {
      array.splice(index, 1);
      this.$forceUpdate();
    },
    _forceUpdate() {
      this.$forceUpdate();
    },
    initialize() {
      this.getProduct();
    },
    checkAll(item) {
      item.selectedOta = [];
      item.otaDtos.forEach((e) => {
        item.selectedOta.push(e.id);
      });
      this.$forceUpdate();
    },
    removeAll(item) {
      item.selectedOta = [];
      this.$forceUpdate();
    },
    changDateApply() {
      this.editedItem.startDate = moment(this.applyDate[0]).format("YYYY-MM-DD");
      this.editedItem.endDate = moment(this.applyDate[1]).format("YYYY-MM-DD");
      this.checkDisabled();
    },
    checkDisabled() {
      this.dateDisabled = {
        MON: true,
        TUE: true,
        WED: true,
        THU: true,
        FRI: true,
        SAT: true,
        SUN: true,
      };
      var start = moment(this.applyDate[0], "YYYY-MM-DD");
      var end = moment(this.applyDate[1], "YYYY-MM-DD");

      // Kiểm tra khoảng ngày hiện tại có lớn hơn 7, nếu lớn hơn thì enable tất cả, nếu ko thì xem khoảng ngày có ngày nào.
      let day = moment.duration(end.diff(start)).asDays();

      // Reset lại toàn bộ
      if (day < 6) {
        while (start <= end) {
          let daysOfWeek = this.formatDateOfWeek(start);
          this.dateDisabled[daysOfWeek] = false;
          start = moment(start).add(1, "day");
          this.$forceUpdate();
        }
      } else {
        // Nếu khoảng ngày trải dài cả tuần thì mở hết.
        this.dateDisabled.MON = false;
        this.dateDisabled.TUE = false;
        this.dateDisabled.WED = false;
        this.dateDisabled.THU = false;
        this.dateDisabled.FRI = false;
        this.dateDisabled.SAT = false;
        this.dateDisabled.SUN = false;
      }

    },
    formatDateOfWeek(date) {
      let dayOfWeek;
      switch (date.day()) {
        case 0: {
          dayOfWeek = "SUN";
          break;
        }
        case 1: {
          dayOfWeek = "MON";
          break;
        }
        case 2: {
          dayOfWeek = "TUE";
          break;
        }
        case 3: {
          dayOfWeek = "WED";
          break;
        }
        case 4: {
          dayOfWeek = "THU";
          break;
        }
        case 5: {
          dayOfWeek = "FRI";
          break;
        }
        case 6: {
          dayOfWeek = "SAT";
          break;
        }
      }
      return dayOfWeek;
    },
    addBlackOut() {
      let prevPeriod =
        this.editedItem.dynamicPricingBlackoutDTOS.length === 0
          ? null
          : this.editedItem.dynamicPricingBlackoutDTOS[
          this.editedItem.dynamicPricingBlackoutDTOS.length - 1
          ];
      if (prevPeriod) {
        let from = moment(prevPeriod.dates[1]).add(1, "day").format("YYYY-MM-DD");
        let to = moment(prevPeriod.dates[1]).add(2, "day").format("YYYY-MM-DD");
        this.editedItem.dynamicPricingBlackoutDTOS.push({
          blackout: true,
          endDate: from,
          startDate: to,
          dates: [new Date(from), new Date(to)],
        });
      } else {
        let from = moment(this.currentDate).add(1, "day").format("YYYY-MM-DD");
        let to = moment(this.currentDate).add(2, "day").format("YYYY-MM-DD");
        this.editedItem.dynamicPricingBlackoutDTOS.push({
          blackout: true,
          endDate: from,
          startDate: to,
          dates: [new Date(from), new Date(to)],
        });
      }
    },
    getProduct() {
      this.isLoading = true;
      dynamicService.getProduct().then((res) => {
        this.product = res.data;
        this.product.forEach((pro) => {
          pro.selectedOta = [];
          pro.otaDtos = pro.otaDtos.filter(e => e.nameVi !== "ezPms")
        });
        this.productList = res.data.map((e) => {
          return {
            text: e.roomType.nameVi + " - " + e.ratePlan.nameVi,
            value: e.roomType.id + "|" + e.ratePlan.id,
          };
        });
        let id = this.$route.params.id;
        this.type = this.$route.params.type;
        if (id != 0) {
          this.isAddNew = false;
          dynamicService.detailDynamic(id).then((res) => {
            this.editedItem = res.data;
            if (this.type === 'COPY') {
              this.editedItem.nameVi = null;
            }
            this.applyDate = [
              new Date(this.editedItem.startDate),
              new Date(this.editedItem.endDate),
            ];
            this.configType = this.editedItem.productDTOList[0].dynamicPricingRangeDTOS[0].rateType;
            this.editedItem.dynamicPricingBlackoutDTOS.map((e) =>
              Object.assign(e, {
                blackout: true,
                dates: [new Date(e.startDate), new Date(e.endDate)],
              })
            );
            this.productSelect = this.editedItem.productDTOList.map(
              (e) => e.roomType.id + "|" + e.ratePlan.id
            );
            // edit_here
            this.product.forEach((pro) => {
              this.editedItem.productDTOList.forEach((proEdit) => {
                if (
                  proEdit.roomType.id + "|" + proEdit.ratePlan.id ===
                  pro.roomType.id + "|" + pro.ratePlan.id
                ) {
                  pro.dynamicPricingRangeDTOS = [...proEdit.dynamicPricingRangeDTOS];
                  proEdit.otaDtos.forEach((ota) => {
                    if (ota.active === 1) {
                      pro.selectedOta.push(ota.id);
                    }
                  });
                }
              });
              pro.selectedOta = Array.from(new Set(pro.selectedOta));
            });
          });
        } else {
          this.isAddNew = true;
          this.applyDate = [
            new Date(moment(this.currentDate).format("YYYY-MM-DD")),
            new Date(moment(this.currentDate).add(1, "day").format("YYYY-MM-DD")),
          ];
        }
        this.isLoading = false;
        setTimeout(() => {
          this.checkDisabled();
        }, 1000);
      });
    },
    addDynamic(item) {
      if (item.dynamicPricingRangeDTOS.length === 0) {
        item.dynamicPricingRangeDTOS.push({
          dynamicPricingAssignmentId: null,
          id: null,
          maxVal: 50,
          minVal: 0,
          paxFriday: "",
          paxMonday: "",
          paxSaturday: "",
          paxSunday: "",
          paxThursday: "",
          paxTuesday: "",
          paxWednesday: "",
          rateAdditional: 0,
          rateIndex: 1,
          rateSupplement: 0,
          rateType: this.configType,
        });
      } else {
        const prev = item.dynamicPricingRangeDTOS[item.dynamicPricingRangeDTOS.length - 1];
        if ((this.editedItem.appliedBy === 1 || prev.maxVal < 100) && prev.maxVal) {
          item.dynamicPricingRangeDTOS.push({
            dynamicPricingAssignmentId: null,
            id: null,
            maxVal: this.editedItem.appliedBy === 0 ? 100 : prev.maxVal + 10,
            minVal: prev.maxVal,
            paxFriday: "",
            paxMonday: "",
            paxSaturday: "",
            paxSunday: "",
            paxThursday: "",
            paxTuesday: "",
            paxWednesday: "",
            rateAdditional: 0,
            rateIndex: 1,
            rateSupplement: 0,
            rateType: this.configType,
          });
        }
      }
    },
    changeProduct() {
      this.product.forEach(item => {
        if (this.productSelect.includes(item.roomType.id + '|' + item.ratePlan.id)) {
          if (item.dynamicPricingRangeDTOS.length === 0) {
            item.selectedOta = [];
            item.otaDtos.forEach((e) => {
              item.selectedOta.push(e.id);
            });
            item.dynamicPricingRangeDTOS.push({
              dynamicPricingAssignmentId: null,
              id: null,
              maxVal: '',
              minVal: 0,
              paxFriday: "",
              paxMonday: "",
              paxSaturday: "",
              paxSunday: "",
              paxThursday: "",
              paxTuesday: "",
              paxWednesday: "",
              rateAdditional: 0,
              rateIndex: 1,
              rateSupplement: 0,
              rateType: this.configType,
            });
          }
        }
      })
    },
    copyPrice(dynamicPricing) {
      let dataCopy = null;
      if (this.dateDisabled.MON === false) {
        dataCopy = dynamicPricing.paxMonday
      } else if (this.dateDisabled.TUE === false) {
        dataCopy = dynamicPricing.paxTuesday
      } else if (this.dateDisabled.WED === false) {
        dataCopy = dynamicPricing.paxWednesday
      } else if (this.dateDisabled.THU === false) {
        dataCopy = dynamicPricing.paxThursday
      } else if (this.dateDisabled.FRI === false) {
        dataCopy = dynamicPricing.paxFriday
      } else if (this.dateDisabled.SAT === false) {
        dataCopy = dynamicPricing.paxSaturday
      } else if (this.dateDisabled.SUN === false) {
        dataCopy = dynamicPricing.paxSunday
      }
      dynamicPricing.paxMonday = this.dateDisabled.MON ? "" : dataCopy;
      dynamicPricing.paxFriday = this.dateDisabled.FRI ? "" : dataCopy;
      dynamicPricing.paxSaturday = this.dateDisabled.SAT ? "" : dataCopy;
      dynamicPricing.paxSunday = this.dateDisabled.SUN ? "" : dataCopy;
      dynamicPricing.paxThursday = this.dateDisabled.THU ? "" : dataCopy;
      dynamicPricing.paxTuesday = this.dateDisabled.TUE ? "" : dataCopy;
      dynamicPricing.paxWednesday = this.dateDisabled.WED ? "" : dataCopy;
    },
    copyMaster(item) {
      this.objectCopy = JSON.parse(JSON.stringify(item.dynamicPricingRangeDTOS));
    },
    pasteMaster(item) {
      if (this.objectCopy) {
        item.dynamicPricingRangeDTOS = [];
        this.objectCopy.forEach((element, index) => {
          item.dynamicPricingRangeDTOS.push(element);
        });
      }
    },
    changeApplyBy() {
      this.product.forEach((e) => {
        e.dynamicPricingRangeDTOS = [];
      });
    },
    update() {
      this.errorCheckOta = false;
      if (!this.$refs.form.validate()) {
        _alert(null, this.$t("_VALIDATE.REQUIRED"));
        return;
      }
      const body = Object.assign({}, this.editedItem);
      const arrProductUpdate = [];
      let check = false;
      if (!body.startDate || !body.endDate) {
        _alert(null, this.$t("_VALIDATE.REQUIRED"));
        return;
      }
      const product = Array.from(new Set(this.product.map(JSON.stringify))).map(JSON.parse);
      product.forEach((e) => {
        if (this.productSelect.includes(e.roomType.id + "|" + e.ratePlan.id)) {
          if (e.selectedOta.length === 0) {
            check = true;
            this.errorCheckOta = true;
            return;
          } else if (e.dynamicPricingRangeDTOS.length === 0) {
            check = true;
            return;
          } else {
            e.otaDtos.forEach((ota) => {
              if (e.selectedOta.includes(ota.id)) {
                ota.active = 1;
              } else {
                ota.active = 0;
              }
            });
            if (!check) {
              delete e.selectedOta;
            }
            e.dynamicPricingRangeDTOS.forEach((dynamicPricing) => {
              dynamicPricing.rateType = this.configType;
              if (!dynamicPricing.maxVal) {
                check = true;
                return;
              } else {
                if (!check) {
                  delete dynamicPricing.dynamicPricingAssignmentId;
                  delete dynamicPricing.id;
                }
                dynamicPricing.paxMonday = this.dateDisabled.MON ? "" : +dynamicPricing.paxMonday;
                dynamicPricing.paxFriday = this.dateDisabled.FRI ? "" : +dynamicPricing.paxFriday;
                dynamicPricing.paxSaturday = this.dateDisabled.SAT ? "" : +dynamicPricing.paxSaturday;
                dynamicPricing.paxSunday = this.dateDisabled.SUN ? "" : +dynamicPricing.paxSunday;
                dynamicPricing.paxThursday = this.dateDisabled.THU ? "" : +dynamicPricing.paxThursday;
                dynamicPricing.paxTuesday = this.dateDisabled.TUE ? "" : +dynamicPricing.paxTuesday;
                dynamicPricing.paxWednesday = this.dateDisabled.WED ? "" : +dynamicPricing.paxWednesday;
              }

            });
            arrProductUpdate.push(e);
          }
        }
      });
      body.productDTOList = Array.from(new Set(arrProductUpdate.map(JSON.stringify))).map(JSON.parse);
      const blackouts = Array.from(new Set(this.editedItem.dynamicPricingBlackoutDTOS.filter(
        (date) => date.blackout
      ).map(JSON.stringify))).map(JSON.parse);
      blackouts.forEach((date) => {
        date.startDate = moment(date.dates[0]).format("YYYY-MM-DD");
        date.endDate = moment(date.dates[1]).format("YYYY-MM-DD");
      });
      body.dynamicPricingBlackoutDTOS = Array.from(new Set(blackouts.map(JSON.stringify))).map(JSON.parse);
      const dates = [];
      body.dynamicPricingBlackoutDTOS.forEach((date) => {
        let fromDate = moment(date.startDate, "YYYY-MM-DD");
        let toDate = moment(date.endDate, "YYYY-MM-DD");
        while (fromDate <= toDate) {
          dates.push(fromDate.format("YYYY-MM-DD"));
          fromDate = moment(fromDate).add(1, "day");
        }
      });
      if (dates.filter((item, index) => dates.indexOf(item) !== index).length > 0) {
        _alert(null, this.$t("_BATCH_UPDATE.MESSAGE.OVERLAP_TIME"));
        return;
      }
      if (check) {
        _alert(null, this.$t("_VALIDATE.REQUIRED"));
        return;
      }
      body.dynamicPricingBlackoutDTOS.forEach((date) => {
        delete date.dates;
        delete date.blackout;
      });
      if (this.isAddNew || this.type === 'COPY') {
        dynamicService.createDynamic(body).then((res) => {
          _alert(res, this.$t(res.data), false);
          this.$router.back();
        });
      } else {
        dynamicService.updateDynamic(body).then((res) => {
          _alert(res, this.$t(res.data), true);
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.subtitle {
  text-transform: uppercase;
  font-size: 15px;
}

.code input {
  text-transform: uppercase;
}

.invalid-text {
  color: red;
  margin-top: -15px;
  position: absolute;
}

.item-cancel-policy {
  border: 1px dashed #cdcdcd;
  padding: 10px;

  p {
    margin-bottom: 0;
  }
}

.item-payment-policy {
  border: 1px dashed #cdcdcd;
  padding: 10px;

  p {
    margin-bottom: 0;
  }
}

.current-cancellation {
  background: linear-gradient(0deg, rgba(0, 62, 148, 0.1), rgba(0, 62, 148, 0.1)), #ffffff;
  padding: 0 10px;
  margin-bottom: 10px;
  border-radius: 5px;

  p {
    margin-bottom: 0;
  }
}
</style>
